module.exports = __webpack_public_path__ + "static/media/mainherodown.540bfd0b.png";